// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.readonly-field[data-v-89241170] input {\n    color: rgba(0, 0, 0, 0.38);\n}\n", ""]);
// Exports
module.exports = exports;
